import React from "react"
import types from "prop-types"
import { categoryShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import UserInfo from "shared/UserInfo"
import { CircularIconButton } from "shared/buttons"
import AccessLevelIdentifier from "./AccessLevelIdentifier"

const GroupGranteeList = ({
  category, groups, updateAccessGranteeLists, deleteAccessLevelGrant,
}) => {
  if (!groups.length) {
    return <div className="m-5">No Group with Grants</div>
  }

  return (
    groups.map(({ id: grantId, grantee: group, accessLevel }) => {
      const { id: groupId, members: groupMembers, name: groupName } = group

      return (
        <>
          <ItemRow
            key={grantId}
            collapsable
            itemRowHeaderContent={(
              <div className="flex flex-row items-center justify-between gap-4 w-full">
                <span>{groupName}</span>
                <AccessLevelIdentifier
                  grantId={grantId}
                  category={category}
                  updateAccessGranteeLists={updateAccessGranteeLists}
                  accessLevel={accessLevel}
                  granteeType="Group"
                  granteeId={groupId}
                  selectLabel={`select access level for ${groupName}`}
                />
              </div>
            )}
            itemRowHeaderControls={(
              <CircularIconButton
                ariaLabel="remove member from group"
                icon="close"
                onClick={deleteAccessLevelGrant(grantId)}
              />
            )}
            itemRowBody={(
              <>
                {
                  groupMembers.map((member) => (
                    <ItemRow
                      key={member.id}
                      className="dark last:mb-0"
                      itemRowHeaderContent={<UserInfo user={member} />}
                    />
                  ))
                }
              </>
            )}
          />
        </>
      )
    })
  )
}

GroupGranteeList.propTypes = {
  category: categoryShape.isRequired,
  groups: types.arrayOf(types.object).isRequired,
  updateAccessGranteeLists: types.func.isRequired,
  deleteAccessLevelGrant: types.func.isRequired,
}

export default GroupGranteeList
